import { request } from '@/api/httpClient'

export async function stockListStockItems({ subCategoryIds, searchText, ListOnlyStockExtras = false }) {
  return request({
    method: 'stock/ListStockItems',
    payload: {
      Limit: 99999,
      Offset: 0,
      subCategoryIds,
      searchText: searchText ?? '',
      ListOnlyStockExtras
    }
  })
}

export async function stockUpdateStockItems(stockItems) {
  return request({
    method: 'stock/UpdateStockItems',
    payload: { stockItems }
  })
}

export async function stockUpdateStockCustomerPrice(stockCustomerPriceDetails) {
  return request({
    method: 'stock/UpdateStockCustomerPrice',
    payload: { stockCustomerPriceDetails }
  })
}

export async function stockListStockCustomerPrice(customerId, itemId) {
  return request({
    method: 'stock/ListStockCustomerPrice',
    payload: {
      CustomerId: customerId,
      stockId: itemId
    }
  })
}

export async function stockListStockParts(query) {
  return request({
    method: 'stock/ListStockParts',
    payload: {
      Limit: 99999,
      Offset: 0,
      SearchText: query
    }
  })
}

export async function stockListStockPartSubCategories() {
  return request({
    method: 'stock/ListStockPartSubCategories',
    payload: {
      Limit: 99999,
      Offset: 0
    }
  })
}

export async function stockListStockPartCategories() {
  return request({
    method: 'stock/ListStockPartCategories',
    payload: {
      Limit: 99999,
      Offset: 0
    }
  })
}
